module.exports = __webpack_public_path__ + "static/media/logo-quiz.9283d03d.png";